import React from "react";

const BackButton = ({navigate}) => {
    return(
        <>
            <button type="button" className="btn border mb-3" onClick={() => { navigate(-1); }} > Back </button>
        </>
    );
}

export default BackButton;
